<template>
  <div id="footer" style="user-select: none">
    <div class="wrapper">
      <div class="content">
        <p>
          <span>版权所有@维普资讯</span>
          <span>
            <a href="https://beian.miit.gov.cn/" target="_blank">
              ICP备案号：渝B2-20050021-14
            </a>
          </span>
          <span>
            <img src="~@/assets/images/beian.png" alt="" />
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002503587&from=index"
              target="_blank"
            >
              渝公网安备 50019002503587号
            </a>
          </span>
          <span>
            <a href="https://www.12377.cn/?from=index" target="_blank">
              违法和不良信息举报中心
            </a>
          </span>
          <span> 举报邮箱：jubao@cqvip.com </span>
          <span>建议浏览器使用firefox、谷歌浏览器</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
